import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eqykpyrhjx: FaireBrandEntity = {
  token: "b_eqykpyrhjx",
  type: "brand",
  name: "The Healing Sanctuary",
  avatarUrl:
    "https://cdn.faire.com/fastly/5f8be4be320d6924a4280d8c356ecc4f9d88bcf286fcc62812bdc081154996d9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ae05f9299e69cf2241fac890d3a3f578e829c7854e2e30d354a7b91fb4a3a67d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5f8be4be320d6924a4280d8c356ecc4f9d88bcf286fcc62812bdc081154996d9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ae05f9299e69cf2241fac890d3a3f578e829c7854e2e30d354a7b91fb4a3a67d.png",
  location: "Washington, MI, USA",
  minimumOrderDollars: 137,
  rating: 4.9,
  reviewCount: 132,
  isTopShop: true,
  isInsider: true,
  description:
    "The Healing Sanctuary is a shop for the mind, body, and soul. All of our gifts are intended for healing and are Infused & Blessed with Reiki Love. Allow our products to assist you on your spiritual journey. In our Sanctuary we house a collection of New Age goods such as crystals, organic herbal teas, books, essential oils, sound healing bowls & so much more.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:32.662Z",
    importedBy: "entity-db-cli",
  },
};
